function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p><strong>JSON DOM-ovan Productions ©</strong></p>
        <p>In conjunction with The Trivia API</p>
      </div>
    </footer>
  )
}

export default Footer